<template>
  <DefaultLayout>
    <div class="flex h-full w-full flex-col items-center justify-center px-4">
      <div
        class="w-full max-w-[28rem] rounded-[1.8rem] border-[10px] border-jm_orange bg-jm_dark_green px-6 py-7 text-center text-jm_white shadow-2xl shadow-black/30"
      >
        <h1 class="text-[24px] font-bold uppercase leading-tight">
          {{ $t("legal_acceptance.title") }}
        </h1>
        <p class="mt-4 whitespace-pre-line text-[16px] leading-snug">
          {{ $t("legal_acceptance.description") }}
        </p>

        <div
          class="mt-6 rounded-2xl border-2 border-jm_orange bg-black/20 p-4 text-left text-[15px] font-bold leading-snug"
        >
          <label class="flex cursor-pointer items-start gap-3">
            <input
              v-model="accepted"
              type="checkbox"
              class="mt-1 h-5 w-5 shrink-0 accent-jm_orange"
            />
            <span>
              {{ $t("legal_acceptance.checkbox_prefix") }}
            </span>
          </label>
          <button
            type="button"
            class="ml-8 mt-2 block text-left font-bold leading-snug text-jm_orange underline decoration-2 underline-offset-4"
            @click.stop="globalStore.openTermsAndConditions('termsAcceptance')"
          >
            {{ $t("legal_acceptance.checkbox_link") }}
          </button>
        </div>

        <button
          type="button"
          class="mt-6 w-full rounded-xl bg-jm_orange px-6 py-3 text-sm font-bold uppercase text-white transition-opacity disabled:cursor-not-allowed disabled:opacity-45"
          :disabled="!accepted || isSubmitting"
          @click="continueToGame"
        >
          {{ $t("legal_acceptance.continue_button") }}
        </button>
      </div>
    </div>
  </DefaultLayout>
</template>

<script setup lang="ts">
import { ref } from "vue";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import { useGlobalStore } from "@/stores/global";
import { useGameTracking } from "@/composables/useGameTracking";

const globalStore = useGlobalStore();
const { kpiTracker, session } = useGameTracking();
const accepted = ref(false);
const isSubmitting = ref(false);

const continueToGame = async () => {
  if (!accepted.value || isSubmitting.value) {
    return;
  }

  isSubmitting.value = true;
  globalStore.acceptLegalConditions(true);
  globalStore.playBackgroundMusic();
  kpiTracker.setConfirmedConsent(true);

  try {
    await session.updateSessionProgress(kpiTracker.getKpiData(), {
      step: "terms_accepted",
    });
  } catch {
    // Tracking failures should not block a user who accepted the legal terms.
  } finally {
    isSubmitting.value = false;
  }

  globalStore.changeStep("shotAnimation");
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/main.sass";
</style>
